import { render } from "./SurveyPriceCalculator.vue?vue&type=template&id=f0791118"
import script from "./SurveyPriceCalculator.vue?vue&type=script&lang=js"
export * from "./SurveyPriceCalculator.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__